import * as React from 'react';
import Svg, {
  SvgProps,
  Rect,
  Defs,
  LinearGradient,
  Stop,
} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={108}
    height={27}
    viewBox={'0 0 108 27'}
    {...props}
    fill="none"
    stroke="none">
    <Rect
      width={107}
      height={26}
      x={0.5}
      y={0.5}
      fill={props.fill || '#033337'}
      fillOpacity={0.8}
      stroke="url(#a)"
      rx={13}
    />
    <Defs>
      <LinearGradient
        id="a"
        x1={0}
        x2={108}
        y1={13.5}
        y2={13.5}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#fff" />
        <Stop offset={0.32} stopColor="#003B49" />
        <Stop offset={0.68} stopColor="#003B49" />
        <Stop offset={1} stopColor="#fff" />
      </LinearGradient>
    </Defs>
  </Svg>
);
export default SvgComponent;
